
import { useParams } from 'react-router-dom';
import { newsArticles } from '../data/newsArticles';

const slugify = (text) => {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

const ArticlePage = () => {
  const { title } = useParams();
  const article = newsArticles.find((article) => slugify(article.title) === title);

  if (!article) {
    return <div>Article not found</div>;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
  };

  return (
    <main className="min-h-screen bg-ballet-light">
      <div className="container-custom section-padding">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-elegant overflow-hidden">
            {article.image && (
              <img src={article.image} alt={article.title} className="w-full h-96 object-cover" />
            )}
            <div className="p-8 md:p-12">
              <h1 className="text-4xl md:text-5xl font-elegant font-bold text-ballet-burgundy mb-4">{article.title}</h1>
              <div className="flex flex-wrap items-center text-gray-600 mb-6">
                <span>{formatDate(article.date)}</span>
                <span className="mx-2">|</span>
                <span className="px-3 py-1 bg-ballet-light text-ballet-burgundy text-sm font-medium rounded-full">{article.category}</span>
              </div>
              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
                <p>{article.excerpt}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ArticlePage;
